export enum TreeType {
    ROUTE_GROUP = 'ROUTE_GROUP',
    ROUTE = 'ROUTE',
    TRIP_PATTERN = 'TRIP_PATTERN',
    CHECKPOINT = 'CHECKPOINT'
}